import {PulseIcon} from '@primer/octicons-react'
import {SkeletonText} from '@primer/react/experimental'
import {memo} from 'react'

import type {Recap} from '../../api/scribe/types'
import styles from './recap-content.module.css'

interface RecapInsightsProps {
  showLoadingSpinner: boolean
  freshInsightData: boolean
  latestRecap: Recap | null | undefined
}

export const RecapInsights = memo(function RecapInsightsComponent({
  showLoadingSpinner,
  freshInsightData,
  latestRecap,
}: RecapInsightsProps) {
  if (!showLoadingSpinner && !(latestRecap?.insights && latestRecap.insights.length > 0)) {
    return null
  }

  return (
    <div className={styles.insightCard}>
      <div className={styles.insightHeader}>
        <h3 className={styles.widgetTitle}>Insights</h3>
      </div>
      {showLoadingSpinner && !freshInsightData ? (
        <div>
          <div className={styles.skeletonText}>
            <SkeletonText lines={3} aria-label="Generating insights" />
          </div>
          <div className={styles.skeletonText}>
            <SkeletonText lines={3} />
          </div>
        </div>
      ) : (
        <ul className={styles.insightList}>
          {latestRecap?.insights?.map(insight => (
            <li key={insight.id} className={styles.insightItem}>
              <PulseIcon size={16} aria-hidden="true" className={styles.insightIcon} />
              <span className={styles.insightText}>{insight.content}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
})
